import React from "react"
import Typography from "aldoo-ra/Typography"
import { ChevronRightIcon } from "@heroicons/react/24/outline"

/**
 * Breadcrumbs component for navigation
 * @param {Object} props
 * @param {Array} props.items - Array of breadcrumb items
 */
const Breadcrumbs = ({ items = [] }) => {
  if (!items || items.length === 0) return null

  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center my-0">
        {items.map((item, index) => {
          const isLast = index === items.length - 1

          return (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="text-gray_700 md:mx-2">
                  <ChevronRightIcon className="w-4 h-4" />
                </span>
              )}

              {!isLast && item.link ? (
                <a
                  href={item.link}
                  onClick={(e) => {
                    e.preventDefault()
                    if (item.onClick) item.onClick()
                  }}
                >
                  <Typography
                    variant="breadcrumbs"
                  >
                    {item.label}
                  </Typography>
                </a>
              ) : (
                <Typography
                  variant="breadcrumbs"
                >
                  {item.label}
                </Typography>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
